import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { verifyMFA } from '../services/api';
import { setAuthToken, setAdminInfo } from '../services/auth';
import './MFAVerification.css';

function MFAVerification({ onLogin }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { email } = location.state || {};

  const [emailCode, setEmailCode] = useState('');
  const [totpCode, setTotpCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [totpRequired] = useState(false);

  useEffect(() => {
    if (!email) {
      navigate('/admin/login');
    }
  }, [email, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await verifyMFA(email, emailCode, totpCode || null);
      setAuthToken(response.token);
      setAdminInfo(response.admin);
      onLogin(response.token);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.message || 'Verifizierung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="login-card">
        <h1>MFA-Verifizierung</h1>
        <form className="login-form" onSubmit={handleSubmit}>
          {error && <div className="error-message">{error}</div>}
          <div className="form-group">
            <label>Email-Code</label>
            <input
              type="text"
              placeholder="6-stelliger Code"
              value={emailCode}
              onChange={(e) => setEmailCode(e.target.value)}
              required
              maxLength={6}
              pattern="[0-9]{6}"
            />
            <small>Der Code wurde an {email} gesendet</small>
          </div>
          {totpRequired && (
            <div className="form-group">
              <label>TOTP-Code</label>
              <input
                type="text"
                placeholder="6-stelliger Code aus Authenticator App"
                value={totpCode}
                onChange={(e) => setTotpCode(e.target.value)}
                maxLength={6}
                pattern="[0-9]{6}"
              />
            </div>
          )}
          <button type="submit" disabled={loading}>
            {loading ? 'Verifizieren...' : 'Verifizieren'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default MFAVerification;






